import { ArrowLeft2, ArrowRight2 } from "iconsax-reactjs";
import { useTranslation } from "react-i18next";
import { DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE, DIAGNOSTICS_HEADER_LABELS } from "@/constants/diagnostics";
import { selectDiagnosticsStep } from "@/store/features/diagnostics/selectors";
import { setDiagnosticsStep } from "@/store/features/diagnostics/slice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Header, Logo, LogoPlaceHolder, Steps, StepItem, StyledBackButton } from "./styled";

const DiagnosticsHeader = () => {
  const { t } = useTranslation();

  const step = useAppSelector(selectDiagnosticsStep);
  const dispatch = useAppDispatch();

  const onClickBack = () => {
    let value = step - 1;

    if (value === DIAGNOSTIC_STEP_PERMISSION_ERROR_VALUE) {
      value -= 1;
    }

    dispatch(setDiagnosticsStep(value));
  };

  return (
    <Header $step={step + 1}>
      {step > 0 ? (
        <StyledBackButton onClick={onClickBack}>
          <ArrowLeft2 size="20" color="var(--color-text-80)" />
          {t('back')}
        </StyledBackButton>
      ) : (
        <div />
      )}
      <Logo />
      <Steps>
        {DIAGNOSTICS_HEADER_LABELS.map((item, index, arr) => {
          const isPassed = item.value <= step;

          return (
            <StepItem key={item.label} $passed={isPassed}>
              <p>{t(item.label)}</p>
              {index !== arr.length - 1 && (
                <ArrowRight2
                  size="20"
                  color={isPassed ? "var(--color-text)" : "var(--color-text-80)"}
                />
              )}
            </StepItem>
          );
        })}
      </Steps>
      <LogoPlaceHolder />
    </Header>
  );
};

export default DiagnosticsHeader;